<ul navAccordion [ngClass]="
    {'matero-sidemenu level-0': displayCSSforMobile,
    'horizontal-stack': !displayCSSforMobile}">
  <li>
    <app-user></app-user>
  </li>
</ul>
